module.exports = __webpack_public_path__ + "static/klaipedos-3cfde4bd31a9edfc4450576c3dcf0e0e.png";